export type tProviderVisibility =
  | { kind: 'always' }
  | { kind: 'nordics' }
  | { kind: 'norway' }
  | { kind: 'apple' }
  | { kind: 'more' };

const NORWAY_TIMEZONES = ['Europe/Oslo', 'Arctic/Longyearbyen'];
const NORDIC_TIMEZONES = [...NORWAY_TIMEZONES, 'Europe/Stockholm', 'Europe/Copenhagen'];

const getTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const isAppleDevice = (): boolean =>
  /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);

export const isNorwegian = (): boolean => NORWAY_TIMEZONES.includes(getTimeZone());

export const isNordic = (): boolean => NORDIC_TIMEZONES.includes(getTimeZone());

export const isProviderPrimary = (visibility: tProviderVisibility): boolean => {
  switch (visibility.kind) {
    case 'always':
      return true;
    case 'nordics':
      return isNordic();
    case 'norway':
      return isNorwegian();
    case 'apple':
      return isAppleDevice();
    case 'more':
    default:
      return false;
  }
};
